import { Type } from '@sinclair/typebox';

const categorySchema = Type.String({
  transform: ['trim', 'toLowerCase'],
});
const typeSchema = Type.String({
  transform: ['trim', 'toLowerCase'],
});
const issuingVersionSchema = Type.Optional(Type.Number());
const issuerSchema = Type.Object(
  {
    type: Type.Optional(Type.String()),
    name: Type.Optional(Type.String()),
    country: Type.String({
      transform: ['trim', 'toUpperCase'],
      enum: [
        'ZZ',
        'AF',
        'AX',
        'AL',
        'DZ',
        'AS',
        'AD',
        'AO',
        'AI',
        'AQ',
        'AG',
        'AR',
        'AM',
        'AW',
        'AU',
        'AT',
        'AZ',
        'BS',
        'BH',
        'BD',
        'BB',
        'BY',
        'BE',
        'BZ',
        'BJ',
        'BM',
        'BT',
        'BO',
        'BQ',
        'BA',
        'BW',
        'BV',
        'BR',
        'IO',
        'BN',
        'BG',
        'BF',
        'BI',
        'KH',
        'CM',
        'CA',
        'CV',
        'KY',
        'CF',
        'TD',
        'CL',
        'CN',
        'CX',
        'CC',
        'CO',
        'KM',
        'CG',
        'CD',
        'CK',
        'CR',
        'CI',
        'HR',
        'CU',
        'CW',
        'CY',
        'CZ',
        'DK',
        'DJ',
        'DM',
        'DO',
        'EC',
        'EG',
        'SV',
        'GQ',
        'ER',
        'EE',
        'ET',
        'FK',
        'FO',
        'FJ',
        'FI',
        'FR',
        'GF',
        'PF',
        'TF',
        'GA',
        'GM',
        'GE',
        'DE',
        'GH',
        'GI',
        'GR',
        'GL',
        'GD',
        'GP',
        'GU',
        'GT',
        'GG',
        'GN',
        'GW',
        'GY',
        'HT',
        'HM',
        'VA',
        'HN',
        'HK',
        'HU',
        'IS',
        'IN',
        'ID',
        'IR',
        'IQ',
        'IE',
        'IM',
        'IL',
        'IT',
        'JM',
        'JP',
        'JE',
        'JO',
        'KZ',
        'KE',
        'KI',
        'KP',
        'KR',
        'KW',
        'KG',
        'LA',
        'LV',
        'LB',
        'LS',
        'LR',
        'LY',
        'LI',
        'LT',
        'LU',
        'MO',
        'MK',
        'MG',
        'MW',
        'MY',
        'MV',
        'ML',
        'MT',
        'MH',
        'MQ',
        'MR',
        'MU',
        'YT',
        'MX',
        'FM',
        'MD',
        'MC',
        'MN',
        'ME',
        'MS',
        'MA',
        'MZ',
        'MM',
        'NA',
        'NR',
        'NP',
        'NL',
        'NC',
        'NZ',
        'NI',
        'NE',
        'NG',
        'NU',
        'NF',
        'MP',
        'NO',
        'OM',
        'PK',
        'PW',
        'PS',
        'PA',
        'PG',
        'PY',
        'PE',
        'PH',
        'PN',
        'PL',
        'PT',
        'PR',
        'QA',
        'RE',
        'RO',
        'RU',
        'RW',
        'BL',
        'SH',
        'KN',
        'LC',
        'MF',
        'PM',
        'VC',
        'WS',
        'SM',
        'ST',
        'SA',
        'SN',
        'RS',
        'SC',
        'SL',
        'SG',
        'SX',
        'SK',
        'SI',
        'SB',
        'SO',
        'ZA',
        'GS',
        'SS',
        'ES',
        'LK',
        'SD',
        'SR',
        'SJ',
        'SZ',
        'SE',
        'CH',
        'SY',
        'TW',
        'TJ',
        'TZ',
        'TH',
        'TL',
        'TG',
        'TK',
        'TO',
        'TT',
        'TN',
        'TR',
        'TM',
        'TC',
        'TV',
        'UG',
        'UA',
        'AE',
        'GB',
        'US',
        'UM',
        'UY',
        'UZ',
        'VU',
        'VE',
        'VN',
        'VG',
        'VI',
        'WF',
        'EH',
        'YE',
        'ZM',
        'ZW',
      ],
    }),
    city: Type.Optional(Type.String()),
    additionalInfo: Type.Optional(Type.Record(Type.String(), Type.Any())),
  },
  {
    additionalProperties: false,
  },
);
export const DocumentsSchema = Type.Array(
  Type.Object(
    {
      id: Type.Optional(Type.String()),
      _id: Type.Optional(Type.String()),
      _document: Type.Optional(Type.Record(Type.String(), Type.Any())),
      category: categorySchema,
      type: typeSchema,
      status: Type.Optional(
        Type.Union([
          Type.String({
            enum: ['requested', 'provided'],
          }),
        ]),
      ),
      issuer: issuerSchema,
      issuingVersion: issuingVersionSchema,
      decisionReason: Type.Optional(Type.Union([Type.String(), Type.Null()])),
      decision: Type.Optional(
        Type.Object(
          {
            status: Type.Optional(
              Type.Union([
                Type.String({
                  enum: ['new', 'pending', 'revision', 'approved', 'rejected'],
                }),
                Type.Null(),
              ]),
            ),
            comment: Type.Optional(Type.String()),
            rejectionReason: Type.Optional(
              Type.Union([
                Type.String(),
                Type.String({
                  enum: [
                    'Fraud Suspected',
                    'Suspicious document',
                    'Document does not match customer profile',
                    'Potential identity theft',
                    'Fake or altered document',
                    'Document on watchlist or blacklist',
                  ],
                }),
              ]),
            ),
            revisionReason: Type.Optional(
              Type.Union([
                Type.String(),
                Type.String({
                  enum: [
                    'Wrong category',
                    'Spam',
                    'Ownership mismatch - Name',
                    'Ownership mismatch - National ID',
                    'Bad image quality',
                    'Missing page',
                    'Invalid document',
                    'Expired document',
                    'Password protected',
                    'Blurry image',
                    'Short statement period',
                    'Document out of range',
                    'Outside restricted area',
                    'Other',
                    'Partial information',
                  ],
                }),
              ]),
            ),
          },
          { additionalProperties: false },
        ),
      ),
      version: Type.Optional(Type.Number()),
      pages: Type.Array(
        Type.Union([
          Type.Object(
            {
              ballerineFileId: Type.String(),
              type: Type.Optional(
                Type.String({
                  enum: [
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-excel',
                    'text/csv',
                    'application/csv',
                    'application/pdf',
                    'image/png',
                    'image/jpg',
                    'image/jpeg',
                    // Backwards compatibility
                    'pdf',
                    'png',
                    'jpg',
                  ],
                }),
              ),
              fileName: Type.Optional(Type.String()),
            },
            { additionalProperties: false },
          ),
          Type.Object(
            {
              ballerineFileId: Type.Optional(Type.String()),
              provider: Type.String({
                enum: ['gcs', 'http', 'stream', 'file-system', 'ftp', 'base64'],
              }),
              uri: Type.String({ format: 'uri' }),
              type: Type.Optional(
                Type.String({
                  enum: [
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-excel',
                    'text/csv',
                    'application/csv',
                    'application/pdf',
                    'image/png',
                    'image/jpg',
                    'image/jpeg',
                    // Backwards compatibility
                    'pdf',
                    'png',
                    'jpg',
                  ],
                }),
              ),
              fileName: Type.Optional(Type.String()),
              data: Type.Optional(Type.String()),
              metadata: Type.Optional(
                Type.Object(
                  {
                    side: Type.Optional(Type.String()),
                    pageNumber: Type.Optional(Type.String()),
                  },
                  { additionalProperties: false },
                ),
              ),
            },
            { additionalProperties: false },
          ),
        ]),
      ),
      properties: Type.Object(
        {
          email: Type.Optional(Type.String({ format: 'email' })),
          expiryDate: Type.Optional(Type.String({ format: 'date' })),
          idNumber: Type.Optional(Type.String()),
        },
        { additionalProperties: true },
      ),
      hiddenIn: Type.Optional(Type.String({ enum: ['backoffice'] })),
    },
    {
      additionalProperties: false,
    },
  ),
);

export const DocumentInsertSchema = Type.Object({
  issuer: issuerSchema,
  category: categorySchema,
  type: typeSchema,
  issuingVersion: issuingVersionSchema,
  version: Type.Optional(Type.Number()),
  propertiesSchema: Type.Object({
    type: Type.Literal('object'),
    properties: Type.Record(
      Type.String(),
      Type.Object({
        type: Type.String(),
        description: Type.Optional(Type.String()),
        format: Type.Optional(Type.String()),
        enum: Type.Optional(Type.Array(Type.Any())),
        minimum: Type.Optional(Type.Number()),
        maximum: Type.Optional(Type.Number()),
        minLength: Type.Optional(Type.Number()),
        maxLength: Type.Optional(Type.Number()),
        pattern: Type.Optional(Type.String()),
      }),
    ),
  }),
  required: Type.Optional(Type.Array(Type.String())),
  additionalProperties: Type.Optional(Type.Boolean()),
});
